import React, { useState } from 'react';
import useI18n from '@i18n';

import Dropdown from './Dropdown';
import Button from './Button';

interface ICommonTypeFilter {
    value: string;
    typesList: {
        value?: string;
        key: string;
        options?: { key: string; value: string }[];
    }[];
    onClick: (value: string) => void;
}

const TypeFilter: React.FC<ICommonTypeFilter> = ({ value: selectedValue, typesList, onClick }) => {
    const { t } = useI18n('Statistic');
    const [visible, setVisible] = useState<boolean>(false);

    return (
        <div
            onScroll={() => setVisible(false)}
            className="flex justify-between mx-auto mb-4 overflow-x-scroll overflow-y-hidden border-b border-blueGray-200 hide-scrollbar hack-max-w-1050px xs:mb-6 sm:mb-8 md:overflow-x-auto"
        >
            {typesList.map(({ key, value, options }) => {
                const isChecked: boolean =
                    selectedValue === value ||
                    !!options?.find(o => o.value === selectedValue) ||
                    false;
                return options ? (
                    <div key={key} className="mr-[32px] last:mr-0">
                        <Dropdown
                            name={key}
                            options={options}
                            isChecked={isChecked}
                            onClick={params =>
                                params?.outside ? setVisible(false) : setVisible(!visible)
                            }
                            callback={onClick}
                            visible={visible}
                        />
                    </div>
                ) : (
                    <div key={key} className="mr-[32px] last:mr-0">
                        <Button onClick={() => onClick(value)} isChecked={isChecked}>
                            {t(key)}
                        </Button>
                    </div>
                );
            })}
        </div>
    );
};

export default TypeFilter;
